import {
  DEFAULT_ASPECT_RATIO,
  DEFAULT_IMAGE_GEN_RESOLUTION,
  SERVICE_NOW_LINK,
} from '@/config/settings';

const initialAIAppState = {
  name: '',
  description: '',
  greetings: '',
  starterPrompts: [],
  instructions: '',
  category: '',
  complianceText: '',
  uploadedIcon: { iconId: null, iconUrl: undefined },
  knowledge: { supportedFileType: 'text', files: [] },
  model: { name_of_model: '', display_name: '' },
  language: '',
  capabilities: { webSearch: false, copyResponse: true, savePrompt: true },
  promptToolsConfig: {
    privateChat: true,
    privateChatMode: true,
    chatWithDocuments: true,
    addSources: true,
    attachFiles: true,
    settings: true,
    changeModel: true,
    changeLanguage: true,
    tools: true,
    savedPrompts: true,
    promptImprover: true,
    brandAgent: false,
    configImage: false,
  },
  isAppPreview: false,
  isAppDisabled: false,
  appCreator: '',
  aiAppId: '',
  appPreviewApiPayload: {},
  appType: '',
  imageGenPayload: {
    aspect_ratio: DEFAULT_ASPECT_RATIO,
    color_palette: [],
    starter_image_id: '',
    image_quality: DEFAULT_IMAGE_GEN_RESOLUTION,
  },
  uploadedImageId: '',
  appFileBadgeTitle: '',
  isAppFileAttached: false,
  imageLoading: false,
  isIntermediatePage: false,
  serviceNowLink: SERVICE_NOW_LINK,
  profitCenter: { value: '', label: '', level: 0, id: '' },
  financeAppLocation: { value: '', label: '', level: 0, id: '' },
  showSQLPannel: false,
  appKey: '',
};

export const aiAppSlice = (set): AIAppContexStore => ({
  ...initialAIAppState,
  preferredTone: '',
  customInstructions: '',
  isAppTerminated: false,
  favouriteAgent: [],
  appFavourite: {
    agent_id: '',
    is_favourite: false,
  },
  attachedFileArray: [],
  isFileDropped: false,
  memory: {
    enabled: false,
    last_synced_at: '',
    summary: '',
  },
  setMemory: (memory) => set(() => ({ memory: memory })),
  setCustomInstructions: (customInstructions) =>
    set(() => ({ customInstructions: customInstructions })),
  setPreferredTone: (preferredTone) => set(() => ({ preferredTone: preferredTone })),
  setName: (name) => set(() => ({ name: name })),
  setDescription: (description) => set(() => ({ description: description })),
  setGreetings: (greetings) => set(() => ({ greetings: greetings })),
  setStarterPrompts: (prompts) => set({ starterPrompts: prompts }),
  setInstructions: (instructions) => set(() => ({ instructions: instructions })),
  setCategory: (category) => set(() => ({ category: category })),
  setComplianceText: (complianceText) => set(() => ({ complianceText: complianceText })),
  setUploadedIcon: (uploadedIcon) =>
    set((state) => ({
      uploadedIcon:
        typeof uploadedIcon === 'function'
          ? (uploadedIcon as (prev: UploadedIcon) => UploadedIcon)(state.uploadedIcon)
          : uploadedIcon,
    })),
  setKnowledge: (knowledge) =>
    set((state) => ({
      knowledge:
        typeof knowledge === 'function'
          ? (knowledge as (prev: Knowledge) => Knowledge)(state.knowledge)
          : knowledge,
    })),
  setModel: (model) => set(() => ({ model: model })),
  setLanguage: (language) => set(() => ({ language: language })),
  setCapabilities: (capabilities) => set(() => ({ capabilities: capabilities })),
  setPromptToolsConfig: (promptToolsConfig) =>
    set(() => ({ promptToolsConfig: promptToolsConfig })),
  setIsAppPreview: (isAppPreview) => set(() => ({ isAppPreview: isAppPreview })),
  setIsAppDisabled: (isAppDisabled) => set(() => ({ isAppDisabled: isAppDisabled })),
  setAppCreator: (appCreator) => set(() => ({ appCreator: appCreator })),
  setAiAppId: (aiAppId) => set(() => ({ aiAppId: aiAppId })),
  setAppPreviewApiPayload: (appPreviewApiPayload) =>
    set(() => ({ appPreviewApiPayload: appPreviewApiPayload })),
  setAppType: (appType) => set(() => ({ appType: appType })),
  setImageGenPayload: (payload) => set(() => ({ imageGenPayload: payload })),
  setUploadedImageId: (id) => set(() => ({ uploadedImageId: id })),
  setIsAppTerminated: (isAppTerminated) => set(() => ({ isAppTerminated: isAppTerminated })),
  setAppFileBadgeTitle: (appFileBadgeTitle) =>
    set(() => ({ appFileBadgeTitle: appFileBadgeTitle })),
  setIsAppFileAttached: (isAppFileAttached) =>
    set(() => ({ isAppFileAttached: isAppFileAttached })),
  setImageLoading: (value) => set(() => ({ imageLoading: value })),
  setIsIntermediatePage: (value) => set(() => ({ isIntermediatePage: value })),
  setServiceNowLink: (value) => set(() => ({ serviceNowLink: value })),
  setProfitCenter: (value) => set(() => ({ profitCenter: value })),
  setFinanceAppLocation: (value) => set(() => ({ financeAppLocation: value })),
  setShowSQLPanel: (showSQLPannel) => set(() => ({ showSQLPannel: showSQLPannel })),
  resetAIApp: () => set(() => ({ ...initialAIAppState })),
  setAppFavourite: (data) => set({ appFavourite: data }),
  setFavouriteAgent: (data) => set({ favouriteAgent: data }),
  setAppKey: (data) => set({ appKey: data }),
  setAttachedFileArray: (attachedFileArray) =>
    set((state) => ({
      attachedFileArray:
        typeof attachedFileArray === 'function'
          ? (attachedFileArray as (prev: File[]) => File[])(state.attachedFileArray)
          : attachedFileArray,
    })),
  setIsFileDropped: (isFileDropped) => set({ isFileDropped: isFileDropped }),
});
